import { render, staticRenderFns } from "./SafePhone.vue?vue&type=template&id=42e198c6&"
import script from "./SafePhone.vue?vue&type=script&lang=js&"
export * from "./SafePhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports